"use client";

import React from "react";
import SectionLayout from "../ui/SectionLayout";
import { SectionProps } from "./model";
import { getDefaultCmsSection } from "@/utils/helper";
import ContactForm from "../ui/forms/ContactForm";

const ContactFormSectionComponent: React.FC<
  SectionProps<{
    app: any;
    overskrift: string;
    tekst: boolean;
  }> & {
    recaptchaSiteKey: string;
  }
> = ({ cmsSection, app, cmsData, recaptchaSiteKey }) => {
  const config = {
    app: app,
    cmsData: cmsData,
  };

  return (
    <SectionLayout cmsSection={getDefaultCmsSection(cmsSection)}>
      <div className="flex flex-col gap-2">
        <div className="flex flex-col lg:flex-row gap-4">
          <div className="flex flex-col lg:w-1/3">
            <div className="homepage-text-xl">
              {cmsSection.specifics.overskrift}
            </div>
            {cmsSection.specifics.tekst && (
              <div
                className="styled-description homepage-text-sm"
                dangerouslySetInnerHTML={{
                  __html: cmsSection.specifics.tekst ?? "",
                }}
              ></div>
            )}
          </div>
          <div className="flex flex-1 lg:w-2/3">
            <ContactForm config={config} recaptchaSiteKey={recaptchaSiteKey} />
          </div>
        </div>
      </div>
    </SectionLayout>
  );
};

export default ContactFormSectionComponent;
